import HtmlTypeConst from "./HtmlTypeConst"

export default class AnchorTypeConst extends HtmlTypeConst {
    static HREF='href'
    
  }
  